import BadgeLink from 'components/BadgeLink'
import Container from 'components/Container'
import Image from 'components/Image'
import Link from 'components/Link'
import PropTypes from 'prop-types'
import React from 'react'
import theme from 'styles/theme'

const Wrapper = ({ children, ...props }) => <div {...props}>{children}</div>

const CategoryHero = ({ category, title, subtext, image, link }) => {
  const WrapperComponent = link ? Link : Wrapper
  return (
    <Container
      className='CategoryHero'
      wrapperStyles={{
        backgroundColor: theme.colors.creamlessDark,
        marginBottom: '8rem',
        position: 'relative',
      }}
      css={{
        [theme.smallOnly]: {
          width: '100%',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column-reverse',
        },
      }}
    >
      <div
        css={{
          display: 'block',
          padding: '4.5rem 0 2rem',
          [theme.smallOnly]: {
            width: '92%',
            margin: 'auto',
            padding: '3rem 0 4rem',
          },
          [theme.mediumOnly]: {
            width: '45%',
          },
          [theme.medium]: {
            padding: '6rem 0 4rem',
          },
          [theme.large]: {
            padding: '10rem 0',
          },
        }}
      >
        {category && category.map(cat => <BadgeLink to={cat.slug.current}>{cat.title}</BadgeLink>)}
        <WrapperComponent to={link}>
          <h1
            css={{
              ...theme.h2,
              color: theme.colors.spinachDark,
              marginBottom: '1rem',
              maxWidth: '22rem',
            }}
          >
            {title}
          </h1>
          <p
            css={{
              ...theme.h3,
              color: theme.colors.spinachDark,
              margin: 0,
              [theme.medium]: {
                maxWidth: '13em',
              },
            }}
          >
            {subtext}
          </p>
        </WrapperComponent>
      </div>
      {image && (
        <WrapperComponent
          to={link}
          css={{
            [theme.medium]: {
              position: 'absolute',
              right: '0',
              top: '0',
              width: '55%',
              height: '100%',
            },
            [theme.large]: {
              overflow: 'hidden',
            },
          }}
        >
          <Image
            {...image}
            width={630}
            height={380}
            alt={title}
            css={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </WrapperComponent>
      )}
    </Container>
  )
}

CategoryHero.propTypes = {
  category: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      slug: PropTypes.shape({ current: PropTypes.string.isRequired }).isRequired,
    })
  ),
  title: PropTypes.string.isRequired,
  subtext: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  link: PropTypes.object.isRequired,
}

export default CategoryHero
